import React, { useEffect, useState, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Cookies from "js-cookie";
import io from "socket.io-client";
import axios from "axios";
import {
  useHMSActions,
  useHMSStore,
  useAVToggle,
  useVideo,
  selectPeers,
  selectIsConnectedToRoom,
  selectIsPeerAudioEnabled,
  selectIsPeerVideoEnabled,
} from "@100mslive/react-sdk";
import { MicOffIcon, MicOnIcon, ExitIcon, PersonIcon } from "@100mslive/react-icons";
import { Loader } from "../components/Loader";
import * as sdk from 'microsoft-cognitiveservices-speech-sdk';
import { FaClosedCaptioning, FaHandPaper, FaInfoCircle, FaVideo, FaUserFriends } from "react-icons/fa";
import { MdSubtitlesOff, MdGraphicEq  } from "react-icons/md";
//import { GoogleTranslate } from "google-translate-api";
import soundWaves from '../assests/Images/sound-wave.gif';
import aiIcon from '../assests/Images/ai-icon.png';
import MoliAPICall from "../services/MoliAPICall";
import Popup from 'reactjs-popup';
import 'reactjs-popup/dist/index.css';
 
const socketUrl = "https://aiterp-api-dev-ws-as.azurewebsites.net"; // Socket URL
const apiBase = "https://ai-moliaihub774999322363.openai.azure.com/"
const apiKey = "30375a9a17a9477e9a70ca253c56cd84"

// Azure Translator API with Customization
const endpoint = "https://api.cognitive.microsofttranslator.com/translate";
const subscriptionKey = "Lk87LXbMKsdvgVezk5h6QUBydPoQeFoSzcsZ7HWhBbG0IPwUoCVSJQQJ99BAACMsfrFXJ3w3AAAbACOGexxF"; // Store securely
const region = "westus3"; // Replace with your region
const categoryId = "fea559c7-2556-47ac-82d3-46cd80b122b7-LAW"
 
 
const Room = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const hmsActions = useHMSActions();
  const isConnected = useHMSStore(selectIsConnectedToRoom);
  const peers = useHMSStore(selectPeers);
  const { isLocalAudioEnabled, toggleAudio } = useAVToggle();
  const [loading, setLoading] = useState(true);
  const [socket, setSocket] = useState(null);
  const [activeSpeaker, setActiveSpeaker] = useState("");
  const [isMicButtonGreyedOut, setIsMicButtonGreyedOut] = useState(false);
  const [isMicrophoneMuted, setIsMicrophoneMuted] = useState(true);
  const [isHoldingToSpeak, setIsHoldingToSpeak] = useState(false);
  const [transcriptionText, setTranscriptionText] = useState("");
  const [translatedText, setTranslatedText] = useState("");
  const [isRecognizing, setIsRecognizing] = useState(false);
  const [recognizer, setRecognizer] = useState(null);
  const [subtitlesEnabled, setSubtitlesEnabled] = useState(true);
  const [data, setData] = useState(null);
  const [peerCount, setPeerCount] = useState(0);
 
  const queryParams = new URLSearchParams(location.search);
  const sessionId = queryParams.get("sessionId");
  const jobId = queryParams.get("jobId");
  const username = queryParams.get("username");
 
  // Avatar info from cookies
  const avatarInfo = Cookies.get("avatarInfo");
  const avatar = avatarInfo ? JSON.parse(avatarInfo) : null;
  const [isMicOn, setIsMicOn] = useState(true);
  const [isAiSpeaking, setIsAiSpeaking] = useState(false);
  const [isTranscriptionEnabled, setIsTranscriptionEnabled] = useState(true);
  const [isHandRaised, setIsHandRaised] = useState(false);
  const [showMuteMessage, setShowMuteMessage] = useState(false);
  const inactivityTimerRef = useRef(null);
  const [showInstructionsMessage, setShowInstructionsMessage] = useState(true);
  const [translatedInstructions, setTranslatedInstructions] = useState({
    instructions: 'Instructions',
    point1: 'Unmute yourself to speak.',
    point2: 'After speaking, please mute yourself.',
    point3: 'Only one peer can speak at a time.',
    okay: 'Okay'
  });

  let sourceLanguageCode = "en";
  let targetLanguageCode = "es";
  let bgColor;



  useEffect(() => {// Get jobId from query params
        if (jobId && !isNaN(jobId)) {
          fetchJobData(jobId);
        } else {
            console.error("Invalid jobId:", jobId);
        }
        console.log('job id is ',jobId);
        
    }, [location]);

  useEffect(() => {
    // Update the peer count whenever `peers` changes
    setPeerCount(peers.length + 1);
    console.log('peer count is ',peerCount);
  }, [peers]);  

  // Fetch job data using MoliAPICall
  const fetchJobData = async (jobId) => {
      const moliAPI = new MoliAPICall(); // Create an instance of MoliAPICall
      try {
          const data = await moliAPI.fetchJobData(jobId); // Call the fetchJobData method on the instance
          console.log(data); // Store the fetched job data in state
          setData(data);
      } catch (error) {
          console.error("Error fetching job data:", error);
      }
  };
  
  const attendeeInfo = Cookies.get("attendeeInfo");
  if (attendeeInfo) {
    try {
        const attendeeData = JSON.parse(attendeeInfo); // Parse JSON
        sourceLanguageCode = attendeeData.sourceLanguageCode || "en";
        targetLanguageCode = attendeeData.targetLanguageCode || "es";
    } catch (error) {
        console.error("Error parsing attendeeInfo cookie:", error);
    }
  }

  
 
  const constantPeer = {
    id: "ai-peer",
    name: avatar ? avatar.avatar_name : "AI",
    avatar_img: avatar ? avatar.avatar_img : "",
    videoTrack: null,
    isLocal: false,
  };
 
  const initSocket = () => {
    const socketInstance = io(socketUrl, {
      transports: ["websocket"],
      path: "/socket.io",
      autoConnect: false,
      reconnection: true,
      reconnectionAttempts: 20,
      reconnectionDelay: 1000,
    });
 
    socketInstance.connect();
    if (socketInstance.disconnected) {
      socketInstance.connect();
    }
 
    socketInstance.on("connect", () => {
      console.log("Connected to server");
      socketInstance.emit("join", { 'roomCode': sessionId, 'username': username });
      listenForActiveSpeaker(socketInstance);
    });
 
    socketInstance.on("reconnect_attempt", (attempt) => {
      console.log("Reconnect attempt:", attempt);
    });
 
    socketInstance.on("reconnect", () => {
      console.log("Reconnected to server");
      socketInstance.emit("join", { 'roomCode': sessionId, 'username': username });
    });
 
    socketInstance.on("disconnect", () => {
      console.log("Disconnected from server");
    });
    
 
    socketInstance.on("synthesizedAudio", (data) => {
      //console.log("audio is: ",data);
      const audioBytes = new Uint8Array(atob(data.audio).split("").map(char => char.charCodeAt(0)));
      const audioBlob = new Blob([audioBytes], { type: "audio/wav" });
      const audioUrl = URL.createObjectURL(audioBlob);
      const audio = new Audio(audioUrl);

      audio.play();

       // Set isAiSpeaking to true when audio actually starts playing
        audio.onplay = () => {
          setIsAiSpeaking(true);
          stopSpeechRecognition();
          setIsMicButtonGreyedOut(true);
          console.log('AI started speaking:', true);
        };

        // Set isAiSpeaking to false when audio finishes
        audio.onended = () => {
          setIsAiSpeaking(false);
          setIsMicButtonGreyedOut(false);
          console.log('AI finished speaking:', false);
        };
    });
 
    // Handle transcription emission
    socketInstance.on("transcription", (data) => {
      //console.log("transription data is: ",data);
      handleTranscription(socketInstance, data);
    });
 
    setSocket(socketInstance);
 
    console.log('is mic off after joining room: ',isMicrophoneMuted);
    console.log('is hand unraised after joining room: ',isHandRaised);


    if(!isMicOn){
      // Initialize Azure Speech recognition with socketInstance
      initAzureSpeechRecognition(socketInstance, false);
    }
    
 
    return () => {
      socketInstance.disconnect();
    };
  };
 
 
  const initAzureSpeechRecognition = async (socketInstance, isMicOn) => {

    if (isMicOn) {
        const speechConfig = sdk.SpeechConfig.fromSubscription('a446630e73514d779093ab5621f15304', 'eastus');
        speechConfig.speechRecognitionLanguage = sourceLanguageCode;

        // const sourceLanguageCode = sourceLanguageCode  || "en";
        // const targetLanguageCode = targetLanguageCode  || "es";
        const languagesWithCustomization = ["ru", "es", "fr", "pt", "so"];

        // console.log('sourceLanguageCode and targetLanguageCode is: ',sourceLanguageCode, targetLanguageCode);

        const audioConfig = sdk.AudioConfig.fromDefaultMicrophoneInput();
        const recognizer = new sdk.SpeechRecognizer(speechConfig, audioConfig);
        setRecognizer(recognizer);

        recognizer.recognized = async (s, e) => {
            if (e.result.reason === sdk.ResultReason.RecognizedSpeech) {
                // console.log(`Recognized: ${e.result.text}`);

                try {
                    let translatedText = e.result.text; // Default to recognized text

                    if (languagesWithCustomization.includes(targetLanguageCode)) {
                        const response = await axios.post(
                            endpoint,
                            [{ text: e.result.text }],
                            {
                                headers: {
                                    "Ocp-Apim-Subscription-Key": subscriptionKey,
                                    "Ocp-Apim-Subscription-Region": region,
                                    "Content-Type": "application/json",
                                },
                                params: {
                                    "api-version": "3.0",
                                    from: sourceLanguageCode,
                                    to: targetLanguageCode,
                                    category: categoryId,
                                },
                            }
                        );

                        if (response.data && response.data[0].translations.length > 0) {
                            translatedText = response.data[0].translations[0].text;
                        }
                    } else {
                        const response = await axios.post(
                            `${apiBase}/translator/text/v3.0/translate`,
                            [{ text: e.result.text }],
                            {
                                headers: {
                                    "Ocp-Apim-Subscription-Key": apiKey,
                                    "Ocp-Apim-Subscription-Region": "westus",
                                    "Content-Type": "application/json",
                                },
                                params: {
                                    from: sourceLanguageCode,
                                    to: targetLanguageCode,
                                },
                            }
                        );

                        if (response.data && response.data[0].translations.length > 0) {
                            translatedText = response.data[0].translations[0].text;
                        }
                    }

                    // Optionally update UI with translated text
                    setTranslatedText(() => `\n${translatedText}`);
                    socketInstance.emit('transcription', {
                        roomCode: sessionId,
                        username: username,
                        transcription: translatedText,
                        language: targetLanguageCode,
                    });

                } catch (error) {
                    console.error("Translation Error:", error);
                }
            }
        };

        recognizer.canceled = (s, e) => {
            console.error(`Canceled: ${e.reason}`);
            recognizer.stopContinuousRecognitionAsync();
        };

        recognizer.sessionStopped = (s, e) => {
            console.log("Session stopped.");
            recognizer.stopContinuousRecognitionAsync();
        };

        // Stop recognition when socket disconnects
        socketInstance.on('disconnect', () => {
            console.log("Socket disconnected, stopping speech recognition...");
            recognizer.stopContinuousRecognitionAsync();
        });

        // Start the recognition process
        recognizer.startContinuousRecognitionAsync();
    } else {
        console.log('Mic is off');
    }
  };

  const stopSpeechRecognition = () => {
    if (recognizer) {
      console.log("stopSpeechRecognition called.");
      recognizer.stopContinuousRecognitionAsync(
        () => {
          console.log("Speech recognition stopped.");
          setIsRecognizing(false);
          setRecognizer(null);
        },
        (err) => {
          console.error("Error stopping speech recognition:", err);
        }
      );
    } else {
      console.log("No recognizer instance found.");
    }
  };


  const handleTranscription = (socketInstance, data) => {
    console.log("handleTranscription called with socketInstance ",socketInstance);
    try {
      const sourceLanguageCode = Cookies.get("sourceLanguageCode") || "en";
      const targetLanguageCode = Cookies.get("targetLanguageCode") || "es"; // Default to Spanish
      const languagesWithCustomization = ["ru", "es", "fr", "pt", "so"];
      // Call the translation API (Azure in this case) for the incoming transcription
      console.log('data is ', data);
      const peerName = data.username;
      const transcription = data.transcription;
      if(peers.isLocal){
          console.log('peer is local peer');
      }

      if(data.transcription){
        console.log('data.transcription is true');
        //if(showMuteMessage){
          // console.log('showMuteMessage is tru');
          setShowMuteMessage((prev) => !prev);
          // Clear any existing timer
          if (inactivityTimerRef.current) {
              console.log('clearing old timer');
              clearTimeout(inactivityTimerRef.current);
          }

          // Start a new timer for 10 seconds
          inactivityTimerRef.current = setTimeout(() => {
            //if (activeSpeaker === data.username) {
              setShowMuteMessage((prevState) => {
                console.log('Mute message after 5 seconds is ', !prevState); // Logs the correct value
                return true; // Ensures the state is set properly
              });
            //}
          }, 10000);
        //}
      }

      const getInitials = (name) => {
        const names = name.split(' ');
        const firstNameInitial = names[0] ? names[0][0] : '';
        const lastNameInitial = names.length > 1 ? names[names.length - 1][0] : '';
        return `${firstNameInitial}${lastNameInitial}`.toUpperCase();
      };

      const colors = [
        "#7BC6CC", // Light Teal
        "#FFDDE1", // Light Pink
        "#E0F7FA", // Light Cyan
        "#FFF9C4", // Light Yellow
        "#F8BBD0", // Light Pink
        "#C5CAE9", // Light Indigo
        "#B2EBF2", // Light Cyan
        "#FFCCBC", // Light Orange
        "#D1C4E9", // Light Purple
        "#B2DFDB", // Light Teal
        "#F0F4C3", // Light Lime
        "#FFE0B2", // Light Peach
        "#C8E6C9", // Light Green
        "#FFECB3", // Light Amber
        "#B3E5FC", // Light Blue
        "#F5F5F5", // Light Gray
        "#E1BEE7", // Light Lavender
        "#DCEDC8", // Light Mint
        "#FFCDD2", // Light Red
        "#BBDEFB", // Light Sky Blue
        "#FFE57F", // Light Gold
        "#CFD8DC", // Light Blue Gray
        "#F48FB1", // Light Pink
        "#80DEEA", // Light Cyan
        "#FFAB91", // Light Coral
        "#A5D6A7", // Light Green
        "#FFCC80", // Light Orange
        "#90CAF9", // Light Blue
        "#CE93D8", // Light Purple
        "#FFE082", // Light Amber
        "#81D4FA", // Light Sky Blue
        "#EF9A9A", // Light Red
        "#B39DDB", // Light Purple
        "#80CBC4", // Light Teal
        "#FFF59D", // Light Yellow
        "#9FA8DA", // Light Indigo
        "#FFAB40", // Light Orange
        "#AED581", // Light Green
        "#64B5F6", // Light Blue
        "#F06292", // Light Pink
        "#4DB6AC", // Light Teal
        "#FFD54F", // Light Amber
        "#7986CB", // Light Indigo
        "#FF8A65", // Light Coral
        "#4DD0E1", // Light Cyan
        "#BA68C8", // Light Purple
        "#FFEE58", // Light Yellow
        "#4FC3F7", // Light Blue
        "#FF6E40", // Light Orange
        "#AED581"  // Light Green
      ];
      
      // Set to keep track of used colors
      const usedColors = new Set();
      
      const generateColor = (name) => {
        let hash = 0;
        for (let i = 0; i < name.length; i++) {
          hash = name.charCodeAt(i) + ((hash << 5) - hash);
        }
        let index = Math.abs(hash) % colors.length; // Pick a color index based on the hash
        let color = colors[index];
      
        // Check if the color has been used
        while (usedColors.has(color)) {
          index = (index + 1) % colors.length; // Move to the next color
          color = colors[index];
        }
      
        usedColors.add(color); // Mark this color as used
        return color;
      };

      // Function to calculate the contrasting text color (black or white)
      const getContrastingTextColor = (hexColor) => {
        // Convert HEX to RGB
        const r = parseInt(hexColor.slice(1, 3), 16) / 255;
        const g = parseInt(hexColor.slice(3, 5), 16) / 255;
        const b = parseInt(hexColor.slice(5, 7), 16) / 255;

        // Calculate relative luminance
        const luminance = 0.2126 * r + 0.7152 * g + 0.0722 * b;

        // Use black or white text based on luminance
        return luminance > 0.5 ? "#000000" : "#FFFFFF";
      };

      const initials = getInitials(peerName);
      bgColor = generateColor(peerName);
      const textColor = getContrastingTextColor(bgColor);

      setTranscriptionText((prevText) => {
        const newLine = `<span style="display: inline-block; width: 30px; height: 30px; border-radius: 50%; background-color:${bgColor}; color: ${textColor}; text-align: center; font-weight: bold; line-height: 30px; margin-top: 2px; margin-bottom: 2px;">${initials}</span><strong style="font-size: 20px; color:${bgColor};" > ${peerName}:</strong> <span >${transcription}</span>`;
        return `${prevText}\n${newLine}`;
      });  

      if (languagesWithCustomization.includes(targetLanguageCode)) {
        axios.post(
          endpoint,
          [{ text: data['transcription'] }],
          {
            headers: {
              "Ocp-Apim-Subscription-Key": subscriptionKey,
              "Ocp-Apim-Subscription-Region": region,
              "Content-Type": "application/json",
            },
            params: {
              "api-version": "3.0",
              from: targetLanguageCode, // English source language
              to: sourceLanguageCode, // Target language
              category: categoryId,
            },
          }
        )
       
        .then((response) => {
        if (response.data && response.data[0].translations.length > 0) {
          const transcriptionText = response.data[0].translations[0].text;
          //setTranscriptionText(transcriptionText);
          // console.log("transcription1",transcriptionText)
        }
      }) .catch((error) =>  {
        console.error("Translation Error:", error);
        // console.log('Translated transcription :', transcriptionText);
      });
    }else{
      axios.post(
        `${apiBase}/translator/text/v3.0/translate`,
        [{ text: data['transcription'] }],
        {
          headers: {
            "Ocp-Apim-Subscription-Key": apiKey,
            "Content-Type": "application/json",
            "Ocp-Apim-Subscription-Region": "westus", // Replace with your region
          },
          params: {
            from: targetLanguageCode,
            to: sourceLanguageCode, // Translate to the target language
          },
        }
      )
      .then((response) => {
        if (response.data && response.data[0].translations.length > 0) {
          const transcriptionText = response.data[0].translations[0].text;
          //setTranscriptionText(transcriptionText);
          // console.log("transcription",transcriptionText)
        }
      })
      .catch((error) => {
        console.error('Error handling transcription data or translation:', error);
      });
    }} catch (error) {
      console.error('Error in handleTranscription:', error);
    }
  };

  // Add this useEffect in your component
  useEffect(() => {
    const transcriptionTextSection = document.querySelector('.transcriptionText-section');
    if (transcriptionTextSection) {
      transcriptionTextSection.scrollTop = transcriptionTextSection.scrollHeight;
    }
  }, [transcriptionText]); // Dependency on transcriptionText state
  
  useEffect(() => {
    initSocket();
  }, []);

   // Fetch and set translated instructions
   useEffect(() => {
    const fetchTranslations = async () => {
      const instructions = {
        instructions: 'Instructions',
        point1: 'Unmute yourself to speak.',
        point2: 'After speaking, please mute yourself.',
        point3: 'Only one peer can speak at a time.',
        okay:'Okay',
      };

      const translated = {
        instructions: await translateInstructions(instructions.instructions, sourceLanguageCode),
        point1: await translateInstructions(instructions.point1, sourceLanguageCode),
        point2: await translateInstructions(instructions.point2, sourceLanguageCode),
        point3: await translateInstructions(instructions.point3, sourceLanguageCode),
        okay: await translateInstructions(instructions.okay, sourceLanguageCode),
      };

      setTranslatedInstructions(translated);
    };

    if (sourceLanguageCode) {
      fetchTranslations();
    }
  }, [sourceLanguageCode]);

  // Function to translate text
  const translateInstructions = async (text, targetLanguage) => {
    // console.log('translateInstructions call with targetLanguage ', targetLanguage);
    try {
      const response = await axios.post(
        endpoint,
        [{ text }],
        {
          headers: {
            "Ocp-Apim-Subscription-Key": subscriptionKey,
            "Ocp-Apim-Subscription-Region": region,
            "Content-Type": "application/json",
        },
          params: {
            "api-version": "3.0",
            from: 'en',
            to: targetLanguage,
            category: categoryId,
          },
        }
      );

      console.log('API Response:', JSON.stringify(response.data, null, 2));

      if (response.data && response.data[0].translations.length > 0) {
        return response.data[0].translations[0].text;
      }
    } catch (error) {
      console.error('Translation Error:', error);
    }
    return text; // Return original text if translation fails
  };
 
 
 
  useEffect(() => {
    if (!loading && !isConnected) {
      navigate("/");
    }
  }, [loading, isConnected, navigate]);
 
  const listenForActiveSpeaker = (socketInstance) => {
    socketInstance.on("active_speaker", (data) => {
      setActiveSpeaker(data.username);
      console.log('active speaker is: ',data.username);
      setIsMicButtonGreyedOut(data.username !== username && data.username !== "");

       // Clear any existing timer
       if (inactivityTimerRef.current) {
          console.log('clearing old timer');
          clearTimeout(inactivityTimerRef.current);
       }

        // Start a new timer for 10 seconds
        inactivityTimerRef.current = setTimeout(() => {
          //if (activeSpeaker === data.username) {
            setShowMuteMessage((prevState) => {
              console.log('Mute message after 5 seconds is ', !prevState); // Logs the correct value
              return true; // Ensures the state is set properly
            });
          //}
        }, 10000); // 10 seconds
    });
  };
 
  useEffect(() => {
    if (socket) {
      listenForActiveSpeaker(socket);
    }
  
    return () => {
      if (inactivityTimerRef.current) {
        clearTimeout(inactivityTimerRef.current);
      }
    };
  }, [socket, activeSpeaker]);

  
  const holdMic = () => {
    console.log('hold mic called');
    if (socket && socket.connected) {
      socket.emit("hold_mic", { 'roomCode': sessionId,'username': username});
      initAzureSpeechRecognition(socket, true);
      //console.log('emit hold');
      socket.on("mic_granted", (data) => {
        if (data.username === username) {
          if (isMicrophoneMuted) {
            toggleAudio();
          }
          setIsMicrophoneMuted(false);
          setIsHoldingToSpeak(true);
          
        }
      });
 
      socket.on("mic_denied", () => {
        setIsHoldingToSpeak(false);
      });
    }
  };
 
  const releaseMic = () => {
    if (socket && socket.connected) {
      socket.emit("release_mic", { 'roomCode': sessionId,'username': username});
 
      if (!isMicrophoneMuted) {
        toggleAudio(); // Mute the microphone
      }
 
      setIsMicrophoneMuted(true);
      setIsHoldingToSpeak(false);
      setIsMicButtonGreyedOut(false);
      setActiveSpeaker("");
      //initAzureSpeechRecognition(socket, false);
    }
  };
 
  const toggleMicMuteState = () => {
    setIsMicrophoneMuted((prevState) => !prevState);
  };
 
  const joinRoom = async () => {
    try {
      const authToken = await hmsActions.getAuthTokenByRoomCode({ roomCode: sessionId });
      await hmsActions.join({ userName: username, authToken });
      await hmsActions.setLocalAudioEnabled(false);
     
    } catch (error) {
      console.error("Error joining room:", error);
    } finally {
      setLoading(false);
    }
  };
 
  useEffect(() => {
    if (sessionId && username) {
      joinRoom();
    } else {
      setLoading(false);
    }
  }, [sessionId, username, hmsActions]);
 
  if (loading) {
    return <Loader />;
  }

  const togglemic = () => {
    setIsMicOn((prev) => !prev);
    if(showMuteMessage){
       setShowMuteMessage((prev) => !prev);
    }
   

    if (!isMicOn) {
      stopSpeechRecognition();
    }
    
    if(isMicButtonGreyedOut){
      console.log('another use speaking');
    }

    
    if (isHoldingToSpeak) {     
      // If the user is holding the mic, release it
      releaseMic();
    } else {
      // Otherwise, toggle the mic
      holdMic();
    }
  };

  const leaveRoom = () => {
    console.log('leave btn clicked');
    // Disconnect the socket
    if (socket) {
      socket.disconnect();
      console.log("Socket disconnected");
    }

    // Stop continuous speech recognition if recognizer is active
    if (recognizer) {
      recognizer.stopContinuousRecognitionAsync(
        () => {
          console.log("Speech recognition stopped.");
        },
        (err) => {
          console.error("Error stopping speech recognition:", err);
        }
      );
    }
  
    // Call the hmsActions.leave() function to leave the room
    hmsActions.leave();
  };

  const toggleTranscription = () => {
    console.log('toggleTranscription btn clicked');

    setIsTranscriptionEnabled(prevState => {
        if (prevState) {
            console.log('Turning OFF transcription');
        } else {
            console.log('Turning ON transcription');
        }

        console.log('is transcription on after clicking button: ', !prevState); // Logs the correct new state
        return !prevState; // Toggle state correctly
    });
  };

  const raiseHand = () => {
    setIsHandRaised(prevState => {
        if (prevState) {
            console.log('unraised hand');
        } else {
            console.log('raised hand');
        }

        console.log('raised hand after clicking button: ', !prevState); // Logs the correct new state
        return !prevState; // Toggle state correctly
    });
  }

  const showMessage = () => {
    setShowInstructionsMessage((prevState) => !prevState);
  }

  const formatDate = (dateString) => {
    if (!dateString) return ""; // Handle undefined/null case
    const date = new Date(dateString);
    return date.toLocaleDateString('en-US', {
      month: 'long',  // Full month name (e.g., May)
      day: '2-digit', // Two-digit day (e.g., 20)
      year: 'numeric' // Full year (e.g., 2025)
    });
  };
  
  

  return (
    <div style={{ display: 'flex', flexDirection: 'row', height: '100vh' }}>      
      {/* Room Container - Takes 70% of the width */}
      <div className="room-container" style={{ flex: `0 0 ${isTranscriptionEnabled ? '75%' : '100%'}`, display: 'flex', flexDirection: 'column', justifyContent:'center' }}>
         {/* Title Section */}
        <div style={{ 
            fontSize:'22px',
            // fontWeight:'bold',
            color:'#acbfc7',
            margin:'1% 1% 1% 1%',
          }}>
          <FaVideo size={24} style={{ marginRight: '8px', marginBottom:'-2.5px', color:'#7a8b9d' }} />
          {data?.entity?.entity_name} | {data?.job_details?.job_title} Session in {data?.job_details?.language_name} on {formatDate(data?.event_details?.occurrence_event_date)}
        </div>
        
        {/* Popup Trigger */}
        {showInstructionsMessage && (
          <Popup 
            open={showInstructionsMessage} 
            modal 
            onClose={() => setShowInstructionsMessage(false)}
            contentStyle={{
              backgroundColor: '#274461', // Background color for the modal content
              borderRadius: '12px', // Rounded corners for the modal
              width: '400px', // Reduced width for the modal
              maxWidth: '100%', // Ensure it doesn't exceed screen width on small devices
            }}
          >
            {(close) => (
              <div 
                className="p-6 rounded-lg shadow-lg max-w-md"
                style={{
                  backgroundColor: '#274461',
                  color: 'white',
                  padding: '10px',
                }}
              > 

                <h2 style={{ fontSize: '22px' }} className="text-xl font-semibold mb-4">
                  {translatedInstructions.instructions}
                </h2>

                <ul style={{ 
                  marginTop: '10px', 
                  paddingLeft: '20px', 
                  fontSize: '18px', 
                  lineHeight: '1.5', 
                  marginBottom: '10px' 
                }}>
                  <li>{translatedInstructions.point1}</li>
                  <li>{translatedInstructions.point2}</li>
                  <li>{translatedInstructions.point3}</li>
                </ul>

                {/* Okay Button */}
                <div style={{ textAlign: 'center', marginTop: '20px' }}>
                  <button
                    onClick={close}
                    style={{
                      backgroundColor: '#2299c3',
                      color: 'white',
                      padding: '10px 20px',
                      borderRadius: '5px',
                      border: 'none',
                      cursor: 'pointer',
                      fontSize: '16px',
                      fontWeight:'bold'
                    }}
                  >
                    {translatedInstructions.okay}
                  </button>
                </div>
              </div>
            )}
          </Popup>
        )}
        
        <div className="conference-section"
             style={{margin: isTranscriptionEnabled ? '2px 2% 0% 0%' : '2px 0% 0% 0%',}}>
          <button
              style={{
                position: 'absolute',
                top: '8px',
                right: '20px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                gap: '8px',
                backgroundColor: 'rgb(52, 81, 105)',
                border: 'none',
                borderRadius: '4px',
                // padding: '8px 12px',
                cursor: 'pointer',
                height:'40px',
                width:'100px',
              }}
              onClick={() => {
                // Add your button click handler here
                console.log('Button clicked!');
              }}
            >
              <FaUserFriends style={{ fontSize: '20px', color: 'white' }} /> {/* People icon */}
              <span style={{ color: 'white', fontWeight:'bold' }}>{peerCount}</span> {/* Peer count */}
            </button>  
          <div
            className="peers-container"
            style={{ 
              display: 'grid', 
              gridTemplateColumns: `repeat(${isTranscriptionEnabled ? 3 : 4}, 1fr)`, 
              gap: '0rem',
              // padding: '2%',
              width:'100%',
              
              // marginLeft: isTranscriptionEnabled ? '10%' : '20%',
            }}
          >
            <Peer key={constantPeer.id} peer={constantPeer} isAiSpeaking={isAiSpeaking} isHandRaised={isHandRaised} activeSpeaker={activeSpeaker} />
            {peers.map((peer) => (
              <Peer key={peer.id} peer={peer} isAiSpeaking={isAiSpeaking} isHandRaised={isHandRaised} activeSpeaker={activeSpeaker} />
            ))}
          </div>

        </div>
          
        {/* Mute Message */}
        {showMuteMessage && isLocalAudioEnabled && (
          <div style={{marginLeft:'36.5%' ,bottom: '20px', right: '20px', backgroundColor: 'rgba(0, 0, 0, 0.8)', color: 'white', padding: '10px', borderRadius: '5px' }}>
            Please mute yourself if you're not speaking.
          </div>
        )}

        {/* Control Section and Instructions Message */}
        <div style={{ position: 'relative', flex: '0 0 10%', display: 'flex', justifyContent: 'center' }}>
          {/* Control Section */}
          <div className="control-section">
            <div className="control-bar">
              {/* Mic Button with Tooltip */}
              <div className="tooltip-container">
                <button style={{ marginTop: "-2px", width: "52px", height: "52px", backgroundColor: '#345169' }}
                  className={`btn-control ${isLocalAudioEnabled ? "" : "highlight"}`}
                  onClick={togglemic}
                  disabled={isMicButtonGreyedOut}
                >
                  {isMicButtonGreyedOut || !isLocalAudioEnabled ? <MicOffIcon height={28} width={28} /> : <MicOnIcon />}
                </button>
                {isMicButtonGreyedOut && (
                  <span className="tooltip-text">Another peer is speaking</span>
                )}
              </div>

              {/* Instructions Button */}
              <button
                id="instructions-btn"
                style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: "0.25rem", backgroundColor: "#345169", width: "60px" }}
                className="btn btn-danger"
                onClick={showMessage}
              >
                {showMuteMessage ? <FaInfoCircle size={28} /> : <FaInfoCircle size={28} />}
              </button>

              {/* Raise Hand Button */}
              <button
                id="raiseHand-btn"
                style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: "0.25rem", backgroundColor: "#345169", width: "60px" }}
                className="btn btn-danger"
                onClick={raiseHand}
              >
                {isHandRaised ? <FaHandPaper size={28} color="yellow" /> : <FaHandPaper size={28} color="white" />}
              </button>

              {/* Transcription Button */}
              <button
                id="transcription-btn"
                style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: "0.25rem", backgroundColor: "#345169", width: "60px" }}
                className="btn btn-danger"
                onClick={toggleTranscription}
              >
                {isTranscriptionEnabled ? <FaClosedCaptioning size={28} /> : <MdSubtitlesOff size={28} />}
              </button>

              {/* Leave Button */}
              <button
                id="leave-btn"
                style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: "0.25rem", fontSize:'20px' }}
                className="btn btn-danger"
                onClick={leaveRoom}
              >
                <ExitIcon style={{ marginLeft: "0.25rem" }} /> Leave Room
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Footer Container - Takes 30% of the width */}
      {isTranscriptionEnabled && (
        <div className="footer-container" style={{ flex: '0 0 25%', overflow: 'auto' }}>
          <div className="transcriptionText-section">
            <h3 
              style={{
                textAlign: 'center', 
                fontWeight:'bold', 
                padding:'1%', 
                backgroundColor: '#345169', 
                border: '1px solid rgb(70, 72, 80)', 
                borderRadius: '8px', 
                padding: '8px 50px', 
                color: 'white', }}> 
              Live Transcriptions</h3>
              {transcriptionText.split("\n").filter((line) => line.trim() !== "").map((line, index) => (
                <div 
                  key={index} 
                  style={{ 
                    backgroundColor: '#2299c3', 
                    padding: '10px 5px 10px 0px', 
                    borderRadius: '15px', 
                    marginBottom: '10px', 
                    color: 'white' // Adjust text color for better visibility
                  }}
                >
                  <p 
                    style={{ 
                      margin: 0, 
                      whiteSpace: 'pre-wrap', 
                      fontSize: '18px' 
                    }} 
                    dangerouslySetInnerHTML={{ __html: line }} 
                  />
                </div>
              ))}
          </div>
        </div>
      )}
    </div>
  );
  
  
};
 
const Peer = ({ peer, isAiSpeaking, isHandRaised, activeSpeaker }) => {
  const { videoRef } = useVideo({ trackId: peer.videoTrack });
  const isPeerAudioEnabled = useHMSStore(selectIsPeerAudioEnabled(peer.id));
  const isPeerVideoEnabled = useHMSStore(selectIsPeerVideoEnabled(peer.id));

  // Check if the peer is the active speaker or if the AI peer is speaking
  const shouldApplyBorder = (peer.id === "ai-peer" && isAiSpeaking) || activeSpeaker === peer.name;

 return (
  <div className="peer-container">
    {/* Mic Icon Handling */}
    {/**
      {(peer.id === "ai-peer" && isAiSpeaking) ? (
        <div
          style={{
            position: "absolute",
            top: "1rem",
            right: "1rem",
            zIndex: "100",
            backgroundColor: "#293042",
            padding: "0.5rem",
            borderRadius: "0.75rem",
            height: "2rem",
            width: "2rem",
            gap: "0.5rem",
          }}
        >
          <MicOnIcon height={16} width={16} style={{ color: "green" }} /> 
        </div>
      ) : isPeerAudioEnabled ? (
        <div
          style={{
            position: "absolute",
            top: "1rem",
            right: "1rem",
            zIndex: "100",
            backgroundColor: "#293042",
            padding: "0.5rem",
            borderRadius: "0.75rem",
            height: "2rem",
            width: "2rem",
          }}
        >
          <MdGraphicEq size={18} /> 
        </div>
      ) : (
        <div
          style={{
            position: "absolute",
            top: "1rem",
            right: "1rem",
            zIndex: "100",
            backgroundColor: "#293042",
            padding: "0.5rem",
            borderRadius: "0.75rem",
            height: "2rem",
            display:'flex',
            alignItems:'center',
            width: "auto",
            gap: "0.5rem",
          }}
        >
          {peer.isLocal && isHandRaised && <FaHandPaper style={{ color: "yellow" }} />}
          <MicOffIcon height={20} width={20} /> 
        </div>
      )}
    **/}

    {peer.isLocal && isHandRaised && (
      <div
        style={{
          position: "absolute",
          top: "25px",
          right: "20px",
          zIndex: "100",
          backgroundColor: "#293042",
          padding: "0.5rem",
          borderRadius: "0.75rem",
          height: "2rem",
          display: 'flex',
          alignItems: 'center',
          width: "auto",
          gap: "0.5rem",
        }}
      >
        <FaHandPaper style={{ color: "yellow" }} />
      </div>    
    )}

    {peer.id === "ai-peer" && (
      <div
        style={{
          position: "absolute",
          top: "25px",
          left: "10px",
          zIndex: "100",
          // backgroundColor: "#293042",
          padding: "0.5rem",
          borderRadius: "0.75rem",
          height: "2rem",
          display: 'flex',
          alignItems: 'center',
          width: "2rem",
          gap: "0.5rem",
        }}
      >
        <img 
          src={aiIcon}
          alt="AI" 
          style={{ height: "40px", width: "40px" }} 
        />
      </div>    
    )}
   
   {/* {peer.isLocal && isPeerAudioEnabled && (
      <div
        style={{
          position: "absolute",
          top: "1rem",
          right: "1rem",
          zIndex: "100",
          backgroundColor: "#293042",
          padding: "0.5rem",
          borderRadius: "0.75rem",
          height: "2rem",
          display: 'flex',
          alignItems: 'center',
          width: "auto",
          gap: "0.5rem",
        }}
      >
        <img 
          src={soundWaves}
          alt="Sound Wave Animation" 
          style={{ height: "25px", width: "25px" }} 
        />
      </div>
    )} */}


    {/* Video Display */} 
      <video
        ref={videoRef}
        className={`peer-video ${peer.isLocal ? "local" : ""}`}
        autoPlay
        muted
        playsInline
      />

    {/* Video Cover - For AI Peer or Peer without Video */}
    {!isPeerVideoEnabled && (
     <div
     className={`peer-video video-cover`}
     style={shouldApplyBorder ? { border: "3px solid blue" } : {}}
   >
     <div className="avatar-circle">
       {peer.id === "ai-peer" && peer.avatar_img ? (
         <img
           src={peer.avatar_img}
           alt={`${peer.name}'s avatar`}
           className="avatar-img"
         />
       ) : (
         <PersonIcon height={80} width={80} />
       )}
     </div>
   
     <div className="peer-info">
       {peer.name} {peer.isLocal ? "(You)" : ""}
       {isPeerAudioEnabled ? (
         <img
           src={soundWaves}
           alt="Sound Wave Animation"
           style={{
             height: "25px",
             width: "25px",
             marginLeft: "10px",
             marginBottom: "-4px",
           }}
         />
       ) : (
         <MicOffIcon
           height={18}
           width={18}
           style={{ marginLeft: "10px", marginBottom: "-2px" }}
         />
       )}
     </div>
   </div>
   
    )} 
    

    {/* Peer Name */}
    {/* <div style={{ display: 'flex', justifyContent: 'center', width: '100%' }}>
      <div
        className="peer-name"
        style={{
          display: 'inline-flex',
          alignItems: 'center',
          gap: '8px',
          justifyContent: 'center',
          backgroundColor: 'rgb(46, 48, 56)', 
          border: '1px solid rgb(70, 72, 80)', 
          borderRadius: '8px', 
          padding: '2px 50px', 
          color: 'white', 
        }}
      >
        {peer.name} {peer.isLocal ? "(You)" : ""}
        {isPeerAudioEnabled ? <img 
            src={soundWaves}
            alt="Sound Wave Animation" 
            style={{ height: "25px", width: "25px" }} 
          /> : <MicOffIcon height={20} width={20} />}
      </div>
    </div> */}
  </div>
);
};
 
export default Room;